import { html, LitElement } from "lit-element"
import { styleMap } from "lit-html/directives/style-map"
import { classMap } from "lit-html/directives/class-map"

export default class extends LitElement {
	static get properties () {
		return {
			layer: { type: Number }, // padding-left用レイア

			isSelected: { type: Boolean }, // ノードが選択状態かどうか
			isExpanded: { type: Boolean }, // ノードが展開状態かどうか

			icon: { type: String }, // ノードのアイコン
			iconType: { type: String }, // ノードアイコン種別
			text: { type: String }, // ノードに表示する名称
			subText: { type: String }, // ノードに表示する件数

			parentNode: { type: Object }, // 親ノードオブジェクト
			childNodes: { type: Array }, // 子ノードリスト

			showCheckbox: { type: Boolean }
		}
	}

	#EXPAND_ICON_MORE = "fas fa-angle-down";
	#EXPAND_ICON_LESS = "fas fa-angle-right";
	ICON_FOLDER = "fas fa-folder fw";
	ICON_FOLDER_OPEN = "fas fa-folder-open fw";

	#checkedInternaly = false

	get checked () {
		return this.#checkedInternaly || this.isExpanded
	}

	constructor (tree) {
		super()
		this.layer = 0

		this.isSelected = false
		this.isExpanded = false

		this.icon = ""
		this.iconType = ""
		this.text = ""
		this.subText = ""
		this.showCheckbox = tree.showCheckbox

		this.parentNode = {}
		this.childNodes = []
		this.userData = {}
	}

	render (showIcon, expandIcon) {
		return html`
			<div class=${this.#nodeClass} style=${this.#nodeStyle} @click="${() => { this.expandOrClose() }}">
				<bui-icon class=${this.#expandIconClass(expandIcon)} icon=${this.#expandCheck}></bui-icon>
				${this.showCheckbox ? html`<input type="checkbox" .checked=${this.checked}>` : ""}
				<bui-icon class=${this.#nodeIconClass(showIcon)} icon=${this.icon}></bui-icon>
				<span class="text">${this.text}</span>
				<span class="subText">${this.subText}</span>
			</div>
		`
	}

	/** ノードのスタイル設定 */
	get #nodeStyle () {
		return styleMap({
			"padding-left": `${15 * this.layer}px`,
			display: "flex"
		})
	}

	/** ノードのクラスを設定 */
	get #nodeClass () {
		return classMap({
			"tree-node-wrapper": true,
			"is-selected": this.isSelected,
			"is-folder": this.iconType === "1"
		})
	}

	/** 展開アイコンクラス */
	#expandIconClass (expandIcon) {
		return classMap({
			"expand-icon": true,
			// icon: true,
			"hide-expand-icon": !expandIcon
		})
	}

	/** ノードアイコンクラス */
	#nodeIconClass (showIcon) {
		return classMap({
			"node-icon": true,
			// icon: true,
			"hide-icon": !showIcon
		})
	}

	#toggleCheck () {
		this.#checkedInternaly = !this.#checkedInternaly
	}

	/** 展開アイコン設定 */
	get #expandCheck () {
		if (this.iconType === "1") {
			if (this.isExpanded) {
				// 展開
				return this.#EXPAND_ICON_MORE
			}
			// 非展開
			return this.#EXPAND_ICON_LESS
		} else {
			// フォルダじゃない場合は非表示
			return ""
		}
	}

	/** ノード名称変更処理 */
	changeName (text) {
		this.text = text
	}

	/** アイコン設定 */
	setIcon (icon) {
		this.icon = icon
	}

	/**
	 * ノード選択処理
	 */
	selectNode () {
		// 親ノード取得
		const parentNode = this.parentNode
		if (parentNode !== "" && !parentNode.isExpanded) {
			this.parentNodeExpand(parentNode)
		}
		// ツリービューに連携
		this.dispatchEvent(new CustomEvent("node-selected"))
	}

	/**
	 * 親ノード展開処理
	 */
	parentNodeExpand (node) {
		node.expand()
		if (node.parentNode !== "") {
			this.parentNodeExpand(node.parentNode)
		}
	}

	/**
	 * ノード開閉処理
	 */
	expandOrClose () {
		if (this.iconType === "1") {
			if (this.isExpanded) {
				this.close()
			} else {
				this.expand()
				this.#checkedInternaly = true
			}
		} else {
			this.#toggleCheck()
		}

		// 選択処理
		this.selectNode()
	}

	/**
	 * ノード展開処理
	 */
	expand () {
		if (this.iconType === "1") {
			this.icon = this.ICON_FOLDER_OPEN
		}
		this.isExpanded = true

		// ツリービューに連携
		this.dispatchEvent(new CustomEvent("node-expand"))
	}

	/**
	 * ノード閉じる処理
	 */
	close () {
		if (this.iconType === "1") {
			this.icon = this.ICON_FOLDER
		}
		this.#checkedInternaly = false
		this.childNodes.forEach(node => {
			node.close()
		})
		this.isExpanded = false
	}

	/**
	 * ノード追加処理
	 */
	addNode (node) {
		this.childNodes.push(node)
	}

	/**
	 * 削除処理
	 */
	deleteNode () {
		const parentNode = this.parentNode

		// 親が存在する場合のみ実行
		if (parentNode !== "") {
			for (let i = 0; parentNode.childNodes.length > i; i++) {
				const deleteNode = parentNode.childNodes[i]
				if (deleteNode.userData.folderId === this.userData.folderId) {
					parentNode.childNodes.splice(i, 1)
					break
				}
			}

			// 親ノードを選択状態に
			parentNode.selectNode()
		}
	}
}
